// extracted by mini-css-extract-plugin
export default {"sportsGrid":"SportsGrid_sportsGrid--tH6"};